/**
 * Dependencies
 */
import http from './HttpService'

/**
 * Update a user's preferences on the API
 *
 * @param  {Object} payload
 * @return {Promise}
 */
export const sync = (payload) => {
    return http.put('auth/user-preferences/', payload)
}



// WEBPACK FOOTER //
// ./src/services/UserService.js